<template>
  <div class="file-manager-div">
    <div class="header">
      <div class="h5 font-weight-bold p-2">فایل های چند رسانه ای</div>
      <div class="p-3 close-btn" @click="this.$emit('closeFileManager')"><i class="far fa-times"></i></div>
    </div>
    <ul class="nav nav-tabs">
      <li class="nav-item">
        <a @click="file_page_active = true" :class="'nav-link '+(file_page_active?'active':'')" >
          <i class="far fa-files"></i>&nbsp; فایل ها</a>
      </li>
      <li class="nav-item">
        <a @click="file_page_active = false" :class="'nav-link '+(file_page_active?'':'active')" >
          <i class="far fa-upload"></i>&nbsp;&nbsp;بارگذاری فایل</a>
      </li>
    </ul>
    <div class="tab-content" >
      <div :class="'tab-pane fade '+(file_page_active?'show active':'')" >
        <div class="top_filters row">
          <div class="col-6 col-sm-6 col-md-4">
            <v-select append-to-body
                      v-model="files_type"
                      :reduce="(option)=>option.value" dir="rtl"
                      :options="file_type_options" label="title" placeholder="نوع فایل را انتخاب کنید"></v-select>
          </div>
          <div class="col-6 col-sm-6 col-md-4">
            <CustomInput :without-label="true" type="text" v-model="search_text" placeholder="برای جستجو عبارتی را وارد کنید..."></CustomInput>
          </div>
        </div>
        <div class="main_files">
          <div v-if="files.length" class="files">
            <div @click="selectFile(index)"  v-for="(file,index) in files" :key="index" :class="'file_item '+(checkFileIsChecked(index)?'active':'')" :style="`background-image: url('${file.img_url}')`">
              <i @click="showFileInfo($event,index)" class="info-btn fas fa-info-circle"></i>
            </div>
          </div>
          <div v-else>
            <div class="alert alert-danger">
              فایلی برای نمایش وجود ندارد
            </div>
          </div>
          <button type="button" v-if="files.length" class="btn btn-info" @click="chooseFile">انتخاب فایل</button>
          <nav v-if="total_pages >1" aria-label="Page navigation example" class="d-inline-block ml-2">
            <ul class="pagination">
              <li :class="'page-item '+(currentPage === 1?'disabled':'')">
                <a class="page-link" >
                  <i class="far fa-angle-right"></i>
                </a>
              </li>
              <slot v-for="item in pages_array">
                <li
                    :class="'page-item '+((item) === currentPage?'active':'')+(!item?'disabled':'')">
                  <a class="page-link" @click="changeCurrentPage(item)" >{{(item?item:'...')}}</a>
                </li>
              </slot>
              <li :class="'page-item '+(currentPage === total_pages?'disabled':'')">
                <a @click="changeCurrentPage(currentPage+1)" :class="'page-link '+(currentPage === total_pages?'disabled':'')"  aria-label="Next">
                  <i class="far fa-angle-left"></i>
                </a>
              </li>
            </ul>
          </nav>
        </div>
        <div class="file-info-div" :style="{width : (info_open?'300px':'0')}">
          <div class="file-info-header">
            <div class="h5 p-2">اطلاعات فایل</div>
            <div class="p-3" @click="info_open = false"><i class="far fa-times fa-2x"></i></div>
          </div>
          <div v-if="file_info">
            <div class="info-img">
              <img :src='file_info.img_url' alt=""/>
              <button type="button" class="btn btn-danger btn-sm del-btn" @click="deleteFile"><i class="far fa-trash-can"></i></button>
            </div>
            <div class="file-info-body">
              <div>{{file_info.title}}
              </div>
              <hr/>
              <AjaxForm :route="'admin/Filemanager/SaveInfo/'+file_info._id" :callback="fileInfoEditCallback">
                <CustomInput label="عنوان" name="title" type="text" v-model="file_info.title"></CustomInput>
                <CustomInput label="متن جایگزین" name="alt" type="text" v-model="file_info.alt"></CustomInput>
                <CustomInput label="توضیح" name="content" type="textarea" v-model="file_info.content"></CustomInput>
                <button class="btn btn-block btn-info mb-3" type="submit">ویرایش اطلاعات</button>
              </AjaxForm>
            </div>
          </div>
          <div v-else>فایلی انتخاب نشده است</div>
        </div>
      </div>
      <div :class="'tab-pane fade '+(!file_page_active?'show active':'')" >
        <FileManagerUploadFiles v-if="!file_page_active" @filesUploaded="addUploadedFiles"></FileManagerUploadFiles>
      </div>
    </div>
  </div>
</template>

<script>
import CustomInput from "@/components/CustomInput";
import {AppApi} from "@/api/AppApi";
import AjaxForm from "@/components/forms/AjaxForm";
import {searchInObjArray, showSystemNoti} from "@/shared/helper";
import Swal from 'sweetalert2';
import vSelect from 'vue-select'
import FileManagerUploadFiles from "@/components/FileManagerUploadFiles";
export default {
  name: "FileManager",
  components: {FileManagerUploadFiles, AjaxForm, CustomInput,vSelect},
  mounted()
  {
    this.getFiles();
  },
  props:{gallery : {type : Boolean,default : false}},
  data(){
    return{
      file_page_active : true,
      apiUrl : process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PATH,
      file_type_options :[
        {title : 'همه',value :'all'},
        {title : 'تصاویر',value :'image'},
        {title : 'ویدیو',value :'video'},
        {title : 'صوتی',value :'audio'},
      ],
      files_type : 'image',
      search_text: '',
      files : [],
      info_open: false,
      file_info : null,
      active_index : null,
      number : 30,
      total_pages : 1,
      total_files : 1,
      currentPage:1 ,
      pages_array :[],
      selected_files : [],
    }
  },
  methods:{
    async getFiles(){
      let offset = (this.currentPage -1 ) * this.number;
      const result = await AppApi.getFiles(this.search_text, this.files_type,offset,this.number);
      if (result.ok)
      {
        this.file_info = null;
        this.info_open= false;
        this.active_index = null;
        const files = result.files;
        this.total_files = Number(result.total);
        this.files = this.fileMakeInfo(files)
      }
      else this.files = [];
    },
    fileMakeInfo(files)
    {
      if (Array.isArray(files))
      {
        for (let i = 0;i<files.length;i++)
        {
          const file = files[i];
          files[i].img_url = this.apiUrl+'storage/uploads/'+file.name;
        }
        return files;
      }
      files.img_url = this.apiUrl+'storage/uploads/'+files.name;
      return files;

    },
    selectFile(index)
    {
      const selected_files = this.selected_files;
      if (this.gallery)
      {
        //باید چندتایی انتخاب کنم
        //باید به لیست فایل اگر فایل نبود اضافه کنم و اگر بود که بردارم
        const file = this.files[index];
        const s_index = searchInObjArray(file._id, selected_files, '_id',true);
        if (s_index !== false)
        {
          selected_files.splice(s_index,1);
        }
        else
        {
          selected_files.push(file);
        }
      }
      else
      {
        const file = this.files[index];
        selected_files[0] =(file);
      }
    },
    showFileInfo(e,index)
    {
      e.preventDefault();
      e.stopPropagation();
      // this.active_index = index;
      this.file_info = this.files[index];
      this.info_open = true;

    },
    async fileInfoEditCallback(data)
    {
      if (data.ok)
      {
        const file = data.file;
        this.file_info = this.fileMakeInfo(file);
        return showSystemNoti('success',data.message)
      }
      else
        return showSystemNoti('danger',data.error);
    },
    async chooseFile()
    {
      if (!this.selected_files.length)
        return showSystemNoti('danger','شما فایلی انتخاب نکرده اید');
      if (this.gallery)
      {
        this.$emit('changeFile',this.selected_files);
        this.$emit('closeFileManager');
      }
      else
      {
        this.$emit('changeFile',this.selected_files[0]);
        this.$emit('closeFileManager');
      }
      // if (this.file_info)
      // {
      //   this.$emit('changeFile',this.file_info);
      //   this.$emit('closeFileManager');
      // }
      // else
      //   return showSystemNoti('danger','شما فایلی انتخاب نکرده اید');
    },
    async deleteFile()
    {
      const file = this.file_info;
      if (!file)
        return showSystemNoti('danger','فایلی انتخاب نشده است.');
      Swal.fire({
        title :'آیا اطمینان دارید',
        text: 'تمامی اطلاعات فایل پاک خواهد شد',
        icon: 'warning',
        confirmButtonText: 'تایید',
        cancelButtonText: 'کنسل',
        showCancelButton: true,
        showCloseButton: true
      }).then(async (result)=>{
        if (result.value)
        {
          const check = await AppApi.deleteFile(this.file_info._id);
          if (check.ok)
          {
            this.files.splice(this.active_index,1);
            this.file_info = null;
            this.info_open= false;
            this.active_index = null;
            return showSystemNoti('success',check.message);
          }
          else
            return showSystemNoti('danger',check.error);
        }
      });
    },
    changeTotalFiles()
    {
      this.pages_array = [];
      const total_files = this.total_files;
      this.total_pages = Math.ceil(total_files / this.number);
      const pages = this.total_pages;
      for (let i = 0;i<pages;i++)
      {
        const index = i+1;
        const currentPage = this.currentPage;
        if (currentPage === index || index === 1 || index === 2 ||index === pages ||index === (pages-1))
          this.pages_array.push(index);
        else if (Math.abs(currentPage - index) <=2)
          this.pages_array.push(index);
        else
        {
          if (this.pages_array[this.pages_array.length -1] !== null)
            this.pages_array.push(null)
        }
      }
    },
    async changeCurrentPage(currentPage)
    {
      if (currentPage)
      {
        this.currentPage = currentPage;
        this.changeTotalFiles();
        await this.getFiles();
      }
    },
    async addUploadedFiles(files)
    {
      for (let i = 0; i < files.length; i++)
        this.files.unshift(this.fileMakeInfo(files[i]));
    },
    checkFileIsChecked(index)
    {
      const selected_files = this.selected_files;
      const file = this.files[index];
      return searchInObjArray(file._id, selected_files, '_id')
    }
  },
  watch:{
    files_type:{
      handler(vale)
      {
        this.currentPage = 1;
        this.getFiles();
      },deep:true
    },
    search_text:{
      handler(vale)
      {
        this.currentPage = 1;
        this.getFiles();
      },deep:true
    },
    total_files:{
      handler(vale)
      {
        this.changeTotalFiles();
      },deep:true
    }
  }
}
</script>

<style scoped>
.file-manager-div
{
  background-color: white;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
  z-index: 90;
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}
.file-manager-div .header
{
  display: flex;
  justify-content: space-between;
}
.close-btn
{
  cursor: pointer;
  font-size: 18px;
}
.tab-pane
{
  position: relative;
  padding: 10px;
}

.files {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  height: calc(100% - 190px);
  overflow-y: auto;
  border: 1px solid silver;
}
.files .file_item {
  flex: 0 0 120px;
  height: 120px;
  margin: 5px;
  background-position: center;
  background-repeat: no-repeat;
  background-size: contain;
  border-radius: 10px;
  box-shadow: -1px 1px 1px 1px #00000054;
  cursor: pointer;
  position: relative;
  z-index: 2;
}
.files .file_item .info-btn {
  position: absolute;
  font-size: 25px;
  left: 0;
  top: 0;
  color: #16266c8a;
  z-index: 4;
  cursor: pointer;
  display: block;
  padding: 5px;
  transition: 400ms;
}
.files .file_item .info-btn:hover {
  color: #16266c;
  transform: scale(1.2);
}
.file_item.active {
  box-shadow: 0 0 3px 1px #dc3545;
}
.file_item.active:after
{
  content: '\f14a';
  font-family: 'Font Awesome 5 Pro';
  position: absolute;
  top: 3px;
  right: 5px;
  font-size: 18px;
  color: #dc3545;
}
.main_files
{
  position: relative;
  overflow-y: auto;
}
.file-info-div
{
  position: absolute;
  left: 0;
  top: 1px;
  /* bottom: 0; */
  border: 1px solid silver;
  height: calc(100% - 100px);
  background: white;
  border-radius: 0 25px 25px 0;
  transition: all 300ms;
  overflow-y: auto;
  z-index: 5;
}
.tab-pane,.main_files,.tab-content
{
  height: 100%;
}

.file-info-header
{
  display: flex;
  justify-content: space-between;
  top: 0;
  right: 0;
  left: 0;
  height: 50px;
  border-bottom: 1px solid silver;
  background: white;
}
.info-img
{
  position: relative;
  width: 150px;
  height: 150px;
  margin: 10px auto 0;
  border-radius: 8px;
  box-shadow: -1px 1px 5px 1px #00000075;
}
.del-btn
{
  position: absolute;
  right: 0;
  top: 0;
}
.info-img img
{
  width: 100%;
  height: 100%;
  display: block;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  object-fit: contain;
}
.file-info-body
{
  padding: 5px;
}
.page-item:not(.disabled,.active)
{
  cursor: pointer;
}
</style>